/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyControlPanel,
  PharmacyControlPanelFromJSON,
  PharmacyControlPanelFromJSONTyped,
  PharmacyControlPanelToJSON,
} from "./";

export const GetControlPanelsResponseTypename = "GetControlPanelsResponse" as const;

/**
 *
 * @export
 * @interface GetControlPanelsResponse
 */
export interface GetControlPanelsResponse {
  /**
   *
   * @type {Array<PharmacyControlPanel>}
   * @memberof GetControlPanelsResponse
   */
  controlPanels?: Array<PharmacyControlPanel>;
  /**
   *
   * @type {number}
   * @memberof GetControlPanelsResponse
   */
  count?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetControlPanelsResponse
   */
  readonly __typename?: string;
}

export function GetControlPanelsResponseFromJSON(json: any): GetControlPanelsResponse {
  return GetControlPanelsResponseFromJSONTyped(json, false);
}

export function GetControlPanelsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetControlPanelsResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetControlPanelsResponseTypename,

    controlPanels: !exists(json, "control_panels")
      ? undefined
      : (json["control_panels"] as Array<any>).map(PharmacyControlPanelFromJSON),
    count: !exists(json, "count") ? undefined : json["count"],
  };
}

export function GetControlPanelsResponseToJSON(object?: GetControlPanelsResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    control_panels:
      value.controlPanels === undefined
        ? undefined
        : (value.controlPanels as Array<any>).map(PharmacyControlPanelToJSON),
    count: value.count,
  };
}
